import React, { useEffect } from "react";
import styles from "./index.module.css";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.bgColor}>
      <div className="main-container">
        <div className="container-content">
          <div className="card-section">
            <div className="main-card">
              <h1 className={`form-title ${styles.title}`}>
                Terms and Conditions
              </h1>
              <div className={styles.termsContent}>
                <p>
                  Welcome to{" "}
                  <a
                    href="https://mylottery.lk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.footerLink}
                  >
                    mylottery.lk
                  </a>
                  . These Terms and Conditions govern your use of our website
                  and the purchase and sale of lotteries from our platform. In
                  addition, all terms and conditions from the National Lotteries
                  Board will apply to every lottery. By accessing and using our
                  website, you agree to comply with the following terms. Please
                  read them carefully before proceeding with any transactions.
                </p>

                <h2>Use of the Website</h2>
                <ul>
                  <li>
                    You must be at least 18 years old to use our website or
                    make purchases.
                  </li>
                  <li>
                    You are responsible for maintaining the confidentiality
                    of your account information, including your username and
                    password.
                  </li>
                  <li>
                    You should provide your NIC/Passport number accurately.
                    This is used as a certification method for lottery winning
                    claims.
                  </li>
                  <li>
                    You agree to provide accurate and current information
                    during the registration and checkout process.
                  </li>
                  <li>
                    You may not use our website for any unlawful or
                    unauthorized purposes.
                  </li>
                </ul>

                <h2>Product Information and Pricing</h2>
                <ul>
                  <li>
                    We strive to provide accurate lottery descriptions,
                    images, and pricing information.
                  </li>
                  <li>
                    Prices are subject to change with notice. Any promotions
                    or discounts are valid for a limited time and may be subject
                    to additional terms and conditions.
                  </li>
                </ul>

                <h2>Orders and Payments</h2>
                <ul>
                  <li>
                    By placing an order for a lottery on our website, you are
                    making an offer to purchase the selected lottery.
                  </li>
                  <li>
                    Lottery selecting facilities can depend on the time. Your
                    selected lottery order will be confirmed only once the
                    transaction is completed.
                  </li>
                  <li>
                    We reserve the right to refuse or cancel any order for any
                    reason, including but not limited to product availability,
                    errors in pricing or product information, or suspected
                    fraudulent activity.
                  </li>
                  <li>
                    Once a subscription for a lottery is activated, it will
                    remain active until it is cancelled or the payment method
                    runs out of funds.
                  </li>
                  <li>
                    You agree to provide valid and up-to-date payment
                    information and authorize us to charge the total order
                    amount to your chosen payment method.
                  </li>
                  <li>
                    We use trusted third-party payment processors to handle your
                    payment information securely. We do not store or have access
                    to your full payment details.
                  </li>
                </ul>

                <h2>Lottery Prize Claims</h2>
                <ul>
                  <li>
                    Rs.40 – Rs.400 winning prizes will be added to the Customer
                    Wallet for other lottery purchases.
                  </li>
                  <li>
                    Rs.400 – Rs.350,000 winning prizes can be added to the
                    Customer Wallet or transferred directly to the customer
                    account upon their request.
                  </li>
                  <li>
                    Rs.350,000 & above winning prizes should be collected from
                    the National Lotteries Board. We will provide you with the
                    necessary assistance and guidelines to complete the process.
                  </li>
                </ul>

                <h2>Delivery</h2>
                <ul>
                  <li>
                    We will make reasonable efforts to ensure to email your
                    purchased lottery on the spot.
                  </li>
                  <li>
                    Technical and connection issues can cause slight delays in
                    the process. However, the ticket will be available in your
                    account under the "My Ticket" tab.
                  </li>
                </ul>

                <h2>Returns and Refunds</h2>
                <ul>
                  <li>
                    Once you make a purchase you will not be eligible for a
                    return or refund as we are dealing with lottery sales.
                  </li>
                  <li>
                    Technical errors from our party will be an exception to this
                    no-return policy. Your payments will be returned within the
                    next 72 hours.
                  </li>
                </ul>

                <h2>Intellectual Property</h2>
                <ul>
                  <li>
                    All content and materials on our website, including but not
                    limited to text, images, logos, and graphics, are protected
                    by intellectual property rights and are the property of{" "}
                    <a
                      href="https://mylottery.lk/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.footerLink}
                    >
                      mylottery.lk
                    </a>{" "}
                    or its licensor Koshara International Private Limited.
                  </li>
                  <li>
                    You may not use, reproduce, distribute, or modify any
                    content from our website without our prior written consent.
                  </li>
                </ul>

                <h2>Limitation of Liability</h2>
                <ul>
                  <li>
                    In no event shall{" "}
                    <a
                      href="https://mylottery.lk/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.footerLink}
                    >
                      mylottery.lk
                    </a>{" "}
                    and its directors, employees, or affiliates be liable for
                    any direct, indirect, incidental, special, or consequential
                    damages arising out of or in connection with your use of our
                    website or the purchase and use of our products.
                  </li>
                  <li>
                    We make no warranties or representations, express or
                    implied, regarding the quality, accuracy, or suitability of
                    the products offered on our website.
                  </li>
                </ul>

                <h2>Amendments and Termination</h2>
                <p>
                  We reserve the right to modify, update, or terminate these
                  Terms and Conditions at any time without prior notice. It is
                  your responsibility to review these terms periodically for any
                  changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
